const WarningIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M12 13.1199V9.37988'
      stroke='#B5912C'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.999 16.125C11.861 16.125 11.749 16.237 11.75 16.375C11.75 16.513 11.862 16.625 12 16.625C12.138 16.625 12.25 16.513 12.25 16.375C12.25 16.237 12.138 16.125 11.999 16.125'
      stroke='#B5912C'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.029 4.13894L21.688 17.5429C22.578 19.1009 21.453 21.0399 19.659 21.0399H4.34101C2.54601 21.0399 1.42101 19.1009 2.31201 17.5429L9.97101 4.13894C10.868 2.56794 13.132 2.56794 14.029 4.13894Z'
      stroke='#B5912C'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default WarningIcon

export const AlternativeWarningIcon = ({
  className = ''
}: {
  className?: string
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='#0FD08B' />
    <path
      d='M12 6V12'
      stroke='#0FD08B'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z'
      fill='#0FD08B'
      stroke='#0FD08B'
    />
  </svg>
)
